import { MODULE_NAME } from 'shared/blocks/selfcare/disney-service/constants';

export const actionType = `@${MODULE_NAME}/FLUSH`;

export default () => ({ type: actionType });
